<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
@if (isRequired()) {
  <span> *</span>
}
@if (feature.comment) {
  <span nbTooltip="{{feature.comment}}"><tui-icon icon="lightbulb"/></span>
}
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <input nbInput
      type="text"
      fullWidth
      fieldSize="medium"
      [placeholder]="valueExample !== null ? valueExample : featureValuePlaceholder"
      formControlName="featureValue"
      />
    @if (featureValue.invalid && (featureValue.dirty || featureValue.touched)) {
      <div>
        @if (featureValue.hasError('pattern')) {
          <div class="text-danger" i18n="@@FeatureValueIncorrectError">
        Не корректное значение
      </div>
        }
        @if (featureValue.hasError('required')) {
          <div class="text-danger" i18n="@@FeatureValueRequiredError">
        Поле обязательно для заполнения
      </div>
        }
        @if (featureValue.hasError('min')) {
          <div class="text-danger" i18n="@@FeatureValueMinError">
        Минимальное значение {{ featureValue.errors.min.min }}
      </div>
        }
        @if (featureValue.hasError('max')) {
          <div class="text-danger" i18n="@@FeatureValueMaxError">
        Превышено максимальное значение: {{ featureValue.errors.max.max }}
      </div>
        }
        @if (featureValue.hasError('notInteger')) {
          <div class="text-danger" i18n="@@FeatureValueNotIntegerError">
        Число должно быть целым
      </div>
        }
      </div>
    }
  </form>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    @if (featureValue.valid && isShowEmptyWarning()) {
      <div class="state-warn">
        <tui-icon icon="triangle-alert"/>
      </div>
    }
    @if (featureValue.invalid) {
      <div class="state-err">
        <tui-icon icon="circle-alert"/>
      </div>
    }
    @if (featureValue.valid && !isEmpty()) {
      <div class="state-success">
        <tui-icon icon="check"/>
      </div>
    }
    @if (featureLink) {
      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
        class="entityID"
        target="_blank"
        i18n-nbTooltip="@@OpenFeatureInNewWindow"
        nbTooltip="Открыть характеристику в новом окне"
        >
        #{{ feature.featureId }}
      </a>
    }
    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>
</div>
